// extracted by mini-css-extract-plugin
export default {"container":"aD-z","dimension":"bD-z","dimensionLabels":"cD-z"};